// src/components/Header.tsx hardened/refactored v1

import React from "react";
//import { asset } from "@/lib/assets";

interface HeaderProps {
  onLogoClick: () => void;
}

// Irregular spacing between words breaks the grid pattern that "Shhh "
// uniformly repeated produces — the wraps land in different places each
// row so it reads as scattered hand-typed whispers, not a column.
const SHHH_WALLPAPER =
  "Shhh  Shhh    Shhh Shhh  Shhh   Shhh    Shhh Shhh  Shhh   Shhh Shhh    Shhh  Shhh Shhh   Shhh    Shhh Shhh  Shhh   Shhh    Shhh Shhh".repeat(
    3,
  );

const Header: React.FC<HeaderProps> = ({ onLogoClick }) => {
  return (
    <header
      className="relative w-full flex flex-col items-center justify-center text-white text-center"
      style={{
        marginTop: 0,
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: 0,
        background: "#2A1A12",
        // Clip the Shhh wallpaper at the dark header's edges so the
        // repeated text can't bleed past the logo/hero area.
        overflow: "hidden",
      }}
    >
      {/* Pure-CSS Shhh wallpaper — replaces the old ShhhTallBackground.png.
          Outer div handles positioning + wrap permission; inner div carries
          the type styling. Tweak color/opacity/size on the inner block. */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          overflow: "hidden",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            display: "block",
            width: "100%",
            height: "100%",
            fontFamily: "'Fredoka', sans-serif",
            fontSize: "clamp(36px, 8vw, 56px)",
            fontWeight: 700,
            color: "rgba(255, 255, 255, 0.12)",
            wordSpacing: "normal",
            letterSpacing: "0.05em",
            textAlign: "justify",
            lineHeight: 1.3,
            whiteSpace: "normal",
            // break-all forces wraps to land mid-"Shhh" sometimes, which
            // disrupts the column rhythm that uniform repeated tokens
            // otherwise produce.
            wordBreak: "break-all",
          }}
        >
          {SHHH_WALLPAPER}
        </div>
      </div>

      <img
        src={"/SVG/banner0507264.svg"}
        alt="CRUSHHH — Go Home"
        className="w-full max-w-[19rem] h-fit px-2 cursor-pointer"
        style={{
          marginTop: 10,
          paddingBottom: 6,
          marginBottom: 0,
          position: "relative",
          zIndex: 1,
        }}
        onClick={onLogoClick}
      />

      {/* Hero copy — lives in the dark header so it reads as one banner. */}
      <div style={{ position: "relative", zIndex: 1, paddingBottom: 6, }}>
        <h1
          className="px-4 leading-snug text-2xl md:text-3xl"
          style={{
            fontFamily: "'Fredoka', sans-serif",
            fontWeight: 700,
            color: "#FDF6EE",
            margin: 0,
            maxWidth: 32 * 16,
          }}
        >
          See What's Already There
        </h1>
      </div>
    </header>
  );
};

export default Header;